import Vue from "vue";
import Router from "vue-router";

import { BASE_URL, TokenType } from "@/helpers/Constants";
import { tokenPermissions } from '@/helpers/claims';
import { checkPermission } from "@/mixins/canWrite";

Vue.use(Router);

export default {
  methods: {
    processRequest(url = "", method = "get", data = {}, showSpinner = true, customURL = false, contentType = "application/json") {
      return this.requestApi(customURL ? url : BASE_URL + url, method, data, showSpinner, true, { contentType, skipAuthorization: customURL });
    },
    requestApi(url = "", method = "get", data = {}, showSpinner = true, showError = true, options = {}) {
      options = { contentType: "application/json", maxRetries: 2, ...options };
      if (showSpinner) {
        if (typeof (showSpinner) === "function") {
          showSpinner(true);
        } else {
          this.$store.commit("addRequest");
          this.$store.commit("setLoad", true);
        }
      }

      let authorization = this.$store.state.token.bearer;
      if (!authorization) authorization = sessionStorage.token || localStorage.token;
      else if ((this.$store.state.token.type & (TokenType.Autogenerated | TokenType.AdminUI | TokenType.Link)) === TokenType.AdminUI) localStorage.token = sessionStorage.token = authorization;
      const headers = new Headers({
        "Content-Type": options.contentType,
        "Access-Control-Allow-Origin": location.origin
      });
      if (authorization && !options.skipAuthorization) headers.set("Authorization", authorization);
      if (!options.skipHeaders) {
        headers.set("RefUrl", location.href);
        headers.set("RefPage", this.$store.state.token.siteId ? 'dynamic' : this.$route.name?.toString());
      }

      const buildOptions = () => {
        const opts = {
          method: method.toUpperCase(),
          headers
        };
        if (method.toLowerCase() !== "get") {
          opts.body = options.contentType === "application/json" ? JSON.stringify(data) : data;
        }
        return opts;
      };
      const defError = () => {
        let path = url;
        const api = url.split('/api');
        if (api.length > 1) path = api.pop();
        else {
          const lambda = url.split('amazonaws.com/');
          if (lambda.length > 1) path = lambda.pop();
        }
        return `Can not ${method} on ${path}`;
      };

      const attemptFetch = (attempt) => {
        return fetch(url, buildOptions()).then(async(resp) => {
          if (!resp.ok) {
            if (resp.status === 401) this.$router.push('/admin/login');
            let text = await resp.text().catch(() => "");
            if (!text && showError) text = defError();
            try { if (text) text = JSON.parse(text); } catch { }
            if (location.origin.includes('localhost') || location.origin.includes('stage') || checkPermission(tokenPermissions.SuperAdmin, this.$store.state.token.permissions)) {
              console.warn(text.message ? text.message + '\n' + text.stackTrace : text);
            }
            if (showError && text) this.$awn.warning(text.message || text);
            return { ok: false, body: text };
          }

          const res = { ok: true, bodyText: await resp.text() };
          try { if (res.bodyText) res.body = JSON.parse(res.bodyText); } catch { res.body = res.bodyText }
          return res;
        }).catch((err) => {
          // retry only on network/CORS errors
          if (attempt < options.maxRetries) return attemptFetch(attempt + 1);
          if (showError) this.$awn.warning(defError());
          return { ok: false, body: err.message || defError() };
        });
      };

      const finalize = () => {
        if (showSpinner) {
          if (typeof (showSpinner) === "function") {
            showSpinner(false);
          } else {
            this.$store.commit("removeRequest");
            if (this.$store.state.activeRequests === 0) this.$store.commit("setLoad", false);
          }
        }
      };

      // Avoid using Promise.prototype.finally for compatibility with older devices
      return attemptFetch(0).then(
        (res) => { finalize(); return res },
        (err) => { finalize(); throw err }
      );
    }
  }
};
